<script>
	import {send, connected} from '@sock/connection'
	import {state} from '@sock/state'

	$: controls = makeControls($state)

	function makeControls(vmix) {
		const ctrls = []

		if (!vmix)
			return ctrls

		if (vmix.inputs)
			vmix.inputs.forEach(input => {
				const steps = []
				let type, key, title, label

				switch (input.type) {
					case 'Browser':
						type = 'overlay-in'
						steps.push({
							command: 'OverlayInput1In Input=' + input.number,
						})
						label = 'GFX on'

						break

					case 'VideoDelay':
						type = 'replay'
						label = 'Replay'
						steps.push({
							command: 'PreviewInput Input=' + input.number,
						})
						steps.push({
							command: 'OverlayInput1Out',
							wait: 600,
						})
						steps.push({
							command: 'Transition3',
							wait: input.duration,
						})
						steps.push({
							control: {type: 'video'},
						})

						break

					case 'Video':
					case 'Capture':
						steps.push({
							command: 'PreviewInput Input=' + input.number,
						})
						steps.push({
							command: 'Transition3',
							wait: 600,
						})
						steps.push({
							control: {type: 'overlay-in'},
						})

						break

					default:
						return
				}

				type ??= input.type.toLowerCase()
				key ??= type + '-' + input.number
				title ??= input.title
				label ??= input.type

				ctrls.push({type, key, label, title, steps})
			})

		if (vmix.overlays)
			vmix.overlays.forEach(overlay => {
				if (overlay.input) {
					ctrls.push({
						type: 'overlay-out',
						key: 'overlay-out-' + overlay.number,
						steps: [
							{command: 'OverlayInput' + overlay.number + 'Out'},
						],
						title: vmix.inputs.find(i => i.number === overlay.input)?.title,
						label: 'GFX Off',
					})

					const inIndex = ctrls.findIndex(c => c.key === 'overlay-in-' + overlay.input)
					if (inIndex > -1)
						ctrls.splice(inIndex, 1)
				}
			})

		return ctrls.sort((a, b) => a.key.localeCompare(b.key))
	}

	async function run(steps) {
		for (const step of steps) {
			if (step.control) {
				const ctrl = controls.find(c => c.type === step.control.type)
				console.log(ctrl)
				console.log(step)
				console.log(controls)

				if (ctrl)
					await run(ctrl.steps)
			}

			if (step.command)
				f(step.command)

			if (step.wait)
				await wait(step.wait)

			// if (step.expect)
		}
	}

	function f(command) {
		send('FUNCTION ' + command, 'control')
	}

	function wait(time) {
		return new Promise(resolve => setTimeout(resolve, time))
	}
</script>

{#if $connected}
	<div>
	{#each controls as control}
		<button
			title={control.title}
			on:click={() => run(control.steps)} >
				{control.label}
		</button>
	{/each}
	</div>
{:else}
	<h2>Not connected</h2>
{/if}

<style>
	div {
		width: 100%;
		padding: 1rem;
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(6rem, 1fr));
		gap: 1rem;
	}
</style>
